import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';


@Component({
  selector: 'app-multi-select-filter',
  templateUrl: './multi-select-filter.component.html',
  styleUrls: ['./multi-select-filter.component.scss']
})
export class MultiSelectFilterComponent<T> implements OnInit {
  @Input() public items: Array<T>[];
  @Input() public value: Array<T>[];
  @Input() public label: string;
  @Input() public idProp: string;
  @Input() public labelProp: string;
  @Input() public allItemsLabel: string;

  @Output() selectionChange = new EventEmitter<T[]>();

  constructor() { }

  ngOnInit(): void {
    console.log("value", this.value);
  }

  updateQuery() {
  }

  onSelectionChange(items: T[]) {
    // if all, emit empty array
    if (items.length == 0) {
      items = [];
    }
    this.selectionChange.emit(items);
  }

  selectAll(matSelect: MatSelect) {
      matSelect.options.forEach((item: MatOption) => item.select());
  }

  deselectAll(matSelect: MatSelect) {
      matSelect.options.forEach((item: MatOption) => item.deselect());
  }
}